import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { DomainName } from "../../Util/Constants";
import { currentDomain, getLogoImagePath } from "../../Util/general-config";

const NotFound = () => {
  const navigate = useNavigate();
  useEffect(() => {
    setTimeout(() => {
      navigate(-1);
    }, 2000);
  }, []);
  let Domain = currentDomain()?.toLowerCase();
  return (
    <div>
      <div className="displaymobile">
        <img
          className="legalsimpli-logo height-37 mt-3 mb-3 ps-20"
          src={getLogoImagePath()}
          alt="PDFsimpli"
          draggable="false"
        />
      </div>
      <section className="section main-content text-center">
        <div className="container intro">
          <div className="row">
            <div className="col-12 headline-group">
              <hgroup>
                <h2>Please wait...</h2>
              </hgroup>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NotFound;
